import { render } from "./ContactLinkedCompanies.vue?vue&type=template&id=5d81b29a&scoped=true"
import script from "./ContactLinkedCompanies.vue?vue&type=script&lang=js"
export * from "./ContactLinkedCompanies.vue?vue&type=script&lang=js"

import "./ContactLinkedCompanies.vue?vue&type=style&index=0&id=5d81b29a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d81b29a"]])

export default __exports__